if (!customElements.get('hollow-shipping-date')) {
  customElements.define('hollow-shipping-date', class extends HTMLElement {
    connectedCallback() {
      const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
      try {
        this.formatter = new Intl.DateTimeFormat('en-US', { ...options, timeZone: this.dataset.timeZone });
      } catch {
        this.formatter = new Intl.DateTimeFormat('en-US', options);
      }
      this.onVisibilityChange = () => {
        if (!document.hidden) this.update();
      };
      this.update();
      this.timer = window.setInterval(() => this.update(), 60000);
      document.addEventListener('visibilitychange', this.onVisibilityChange);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }

    update(now = new Date()) {
      const parts = Object.fromEntries(this.formatter.formatToParts(now).map(part => [part.type, part.value]));
      const tomorrow = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day) + 1));
      const day = tomorrow.getUTCDate();
      const lastTwo = day % 100;
      const suffix = lastTwo >= 11 && lastTwo <= 13 ? 'th' : ({ 1: 'st', 2: 'nd', 3: 'rd' }[day % 10] || 'th');
      const month = new Intl.DateTimeFormat('en-US', { month: 'short', timeZone: 'UTC' }).format(tomorrow).toUpperCase();
      const time = this.querySelector('time');
      if (!time) return;
      time.dateTime = tomorrow.toISOString().slice(0, 10);
      time.textContent = `${month} ${day}${suffix}`;
    }
  });
}
